module.exports = __webpack_public_path__ + "static/img/矿山全场景.b2b12c23.png";